import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 2H2v1.276a2 2 0 0 0 .464 1.28l4.072 4.888A2 2 0 0 1 7 10.724V15l2-1v-3.276a2 2 0 0 1 .464-1.28l4.072-4.888A2 2 0 0 0 14 3.276V2z" />
  </svg>
);
export default IconFunnelSizeS;
